export default __webpack_public_path__ + "static/media/ma.2a9ae9c7.svg";